import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import dayjs from "@/lib/bizday";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrivalDialog } from "@/components/visits/ArrivalDialog";

const SRC = { walk_in: "Walk-in", scheduled: "Scheduled", other_unknown: "Other / Unknown" };

function Row({ v }) {
  const qc = useQueryClient();
  const [asking, setAsking] = useState(false);
  const [reason, setReason] = useState("");
  const voidIt = useMutation({
    mutationFn: () => api.post(`/visits/${v.id}/void`, { reason }),
    onSuccess: () => { toast.success("Arrival removed"); setAsking(false); ["visits", "ci", "visit-for-booking"].forEach((k) => qc.invalidateQueries({ queryKey: [k] })); },
    onError: (e) => toast.error(apiErr(e)),
  });
  return (<li className="py-2 text-sm" data-testid={`arrival-row-${v.id}`}><div className="flex items-center justify-between gap-3">
    <div><b>{v.customer_name}</b> <span className="text-slate-500">· {dayjs(v.arrived_at).format("h:mm A")} · {SRC[v.source]}</span>
      <span className="block text-xs text-slate-500">{v.pet_names.join(", ") || "No pets"} · {v.service_completed ? "service completed" : "service not completed yet"}
        {v.bookings.length ? ` · ${v.bookings.map((b) => b.service_name).join(", ")}` : ""}</span></div>
    <button type="button" onClick={() => setAsking((x) => !x)} data-testid={`arrival-void-${v.id}`} className="text-xs text-rose-600 hover:underline">Remove</button></div>
    {asking && <div className="mt-2 flex gap-2"><Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Why remove it? e.g. recorded by mistake" className="h-8 text-xs" data-testid={`arrival-void-reason-${v.id}`} />
      <Button size="sm" variant="destructive" disabled={reason.trim().length < 3 || voidIt.isPending} onClick={() => voidIt.mutate()} data-testid={`arrival-void-confirm-${v.id}`}>Remove</Button></div>}</li>);
}

export function TodayArrivals() {
  const [open, setOpen] = useState(false);
  const { data } = useQuery({ queryKey: ["visits"], queryFn: async () => (await api.get("/visits")).data });
  return (<div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="today-arrivals">
    <div className="mb-2 flex items-center justify-between"><h3 className="text-sm font-bold">Arrivals recorded today <span className="text-slate-400" data-testid="today-arrivals-count">{data?.count ?? ""}</span></h3>
      <Button size="sm" onClick={() => setOpen(true)} data-testid="record-arrival-btn">Record arrival</Button></div>
    {!data?.items?.length ? <p className="text-xs text-slate-500" data-testid="today-arrivals-empty">No arrivals recorded yet today.</p>
      : <ul className="divide-y divide-slate-100">{data.items.map((v) => <Row key={v.id} v={v} />)}</ul>}
    <ArrivalDialog open={open} onClose={() => setOpen(false)} />
  </div>);
}
